import React from 'react';
import { Edcap } from '../../../Dashboard.styled';
import { Wrap, Title, Meta, GreenButton } from './NextStepPanel.styled';

export interface NextStepPanelProps {
  eyebrow: string;
  title: React.ReactNode;
  meta: React.ReactNode;
  ctaLabel: string | null;
  onCta: () => void;
}

export default function NextStepPanel({ eyebrow, title, meta, ctaLabel, onCta }: NextStepPanelProps) {
  return (
    <Wrap>
      <Edcap tone="green">{eyebrow}</Edcap>
      <Title>{title}</Title>
      {meta && <Meta>{meta}</Meta>}
      {ctaLabel && (
        <GreenButton type="button" onClick={onCta}>
          {ctaLabel}
        </GreenButton>
      )}
    </Wrap>
  );
}
